// extracted by mini-css-extract-plugin
export default {"App":"App_App__4s36N","main":"App_main__z3Xfm"};